import React, {useEffect} from 'react';
import styled, {keyframes, css} from 'styled-components';
import Logo from "../ui/logo";

const fadeIn = keyframes`
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;


const grow = keyframes`
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(2);
        opacity: 1;
    }
`;


const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: #000;
    color: white;
    overflow: hidden;
    position: relative;
`;

const LogoAnimation = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    animation: ${fadeIn} 3000ms ease-out;
`;

const Title = styled.h1`
    font-size: 2.5rem;

    //margin-bottom: 2rem;
    z-index: 2;
    text-align: center;
    font-family: "VK Sans Display", sans-serif;
    font-weight: bolder;
`;

const BlackOval = styled.div`
    position: absolute;
    width: 50%;
    height: 50%;
    background: black;
    //border-radius: 50%;
    z-index: 1;
    //transform: rotate(-22deg);
`;

const BlackOvalAnimation = styled.div`
    animation: ${grow} 5000ms cubic-bezier(0.34, 1.56, 0.64, 1) infinite;
`;


export const PreviewScreen = () => {
    const haptic = () => {
        for (let i = 0; i < 50; i++) {
            setTimeout(() => {
                if (window?.Telegram?.WebApp?.HapticFeedback) {
                    if (window.Telegram.WebApp.platform !== 'tdesktop') {
                        window.Telegram.WebApp.HapticFeedback.impactOccurred("heavy");
                    }
                }
            }, i * 20 - i);
        }
    };

    useEffect(() => {
        haptic();
    }, []);

    return (
        <Container>
            <BlackOvalAnimation style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <img src="/images/preview.svg" alt="logo"/>
                <BlackOval/>
            </BlackOvalAnimation>
            <LogoAnimation>
                <Logo/>
                <div style={{
                    fontFamily: 'VK Sans Display, sans-serif',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}>
                    <Title>{process.env.REACT_APP_NAME}</Title>
                    <p style={{opacity: 0.7}}>powered by DeGuard</p>
                </div>
            </LogoAnimation>
        </Container>
    );
};

export default PreviewScreen;